angular.module('dnecom')
    .controller('StoreChartController', ["$scope", "wizardModal", "$http", "$timeout", "notifications", "$location", function ChartController($scope, wizardModal, $http, $timeout, notifications, $location) {
        $scope.report = TemplateData.value('salesReport');
        $scope.storeId = TemplateData.value('store') ? TemplateData.value('store').id : 0;
        $scope.currencyCode = TemplateData.value('store') ? TemplateData.value('store').currencyCode : 'usd';
        $scope.enabledMultiCurrency = TemplateData.value('enabledMultiCurrency');
        if ($scope.enabledMultiCurrency) {
            $scope.currencyCode = TemplateData.value('selectedCurrency');
            $scope.currencies = TemplateData.value('currencyCodes');
            $scope.reportCurrency = $scope.currencyCode;
        }
        $scope.chartPeriod = 1;
        $scope.showOverlay = false;
        $scope.loading = false;


        $scope.init = function() {
            $scope.chartData = {
                labels: Object.keys($scope.report),
                datasets: [
                    {
                        label: 'Orders',
                        data: $scope.getArrayColumn($scope.report, 'orders'),
                        backgroundColor: '#2491FF'
                    },
                    {
                        label: 'Sales',
                        data: $scope.getArrayColumn($scope.report, 'sales'),
                        backgroundColor: '#4BC0C0'
                    }
                ]
            };

            $scope.chartOptions = {
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero:true
                        }
                    }]
                }
            };
        };

        $scope.setChartPeriod = function(days, code) {
            $scope.loading = true;
            if (!code) {
                code = $scope.currencyCode;
            }

            $http
                .post(Routing.generate('stores_sales_report', {
                    'id'   : $scope.storeId,
                    'days' : days,
                    'code' : code,
                }))
                .success(function (response) {
                    if (!response.success) {
                        alert(response.error || 'Failed to fetch data for report.');
                        return;
                    }

                    $scope.chartPeriod = days;
                    $scope.currencyCode = code;
                    $scope.report = response.report;
                    $scope.init();
                })
                .error(function (response) {
                    alert('Failed to fetch data for report.');
                })
                .finally(function() {
                    $scope.loading = false;
                })
            ;
        };

        $scope.nextCurrency = function() {
            let index = $scope.currencies.indexOf($scope.currencyCode);
            $scope.setChartPeriod($scope.chartPeriod, $scope.currencies[index + 1] || $scope.currencies[0]);
        };

        $scope.saveDefaultCurrency = function() {
            $http.post(Routing.generate('stores_default_currency', {code: $scope.reportCurrency}))
                .success(function (response) {
                    $scope.showOverlay = false;
                    $scope.setChartPeriod($scope.chartPeriod, $scope.reportCurrency);
                })
        }

        $scope.getTotalOrders = function() {
            var total = 0;

            for (var key in $scope.report) {
                total += $scope.report[key].orders;
            }

            return total;
        };

        $scope.getTotalSales = function() {
            var total = 0;

            for (var key in $scope.report) {
                total += $scope.report[key].sales;
            }

            return total.toFixed(2);
        };

        $scope.getArrayColumn = function(input, column) {
            var out = [];

            for (var key in input) {
                out.push(input[key][column]);
            }

            return out;
        };

        $scope.toggleOverlay = function () {
            $scope.showOverlay = !$scope.showOverlay;
        }
    }]);
